import { Component, OnInit } from '@angular/core';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nous-contacter',
  templateUrl: './nous-contacter.component.html',
  styleUrls: ['./nous-contacter.component.scss']
})
export class NousContacterComponent implements OnInit {
  configuration: any;
  MAX_FILE_SELECT=this.configurationService.get().nous_contacter.FileLimit;
  MAX_FILE_SIZE=this.configurationService.get().nous_contacter.FileSize;
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);
  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private configurationService: ConfigurationService) { }
  ngOnInit(): void {

    this.configuration = this.configurationService.get();
  }

}
